import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ComicCard from '@/components/base/ComicCard';
import { comics, categories } from '@/mocks/comics';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find(c => c.slug === slug);

  const filteredComics = slug === 'all'
    ? comics
    : comics.filter(c => c.categorySlug === slug);

  const displayName = category?.name || slug || '未知分类';

  const categorySchema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "name": `${displayName}韩漫 - 韩漫画网`,
        "url": `http://coffeemate.cn/category/${slug}`,
        "description": `韩漫画网${displayName}分类，提供免费${displayName}类韩国漫画在线阅读，无删减下拉式韩漫大全`,
        "isPartOf": { "@type": "WebSite", "name": "韩漫画网", "url": "http://coffeemate.cn/" }
      },
      {
        "@type": "BreadcrumbList",
        "itemListElement": [
          { "@type": "ListItem", "position": 1, "name": "首页", "item": "http://coffeemate.cn/" },
          { "@type": "ListItem", "position": 2, "name": `${displayName}韩漫`, "item": `http://coffeemate.cn/category/${slug}` }
        ]
      }
    ]
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(categorySchema) }} />
      <Navbar />

      <main className="pt-16">
        <section className="relative w-full min-h-[360px] md:min-h-[440px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20art%20style%20illustration%20with%20multiple%20comic%20characters%20arranged%20in%20dynamic%20composition%2C%20warm%20and%20vibrant%20colors%2C%20comic%20panel%20layout%20elements%2C%20artistic%20webtoon%20style%2C%20energetic%20and%20engaging%20visual%2C%20colorful%20speech%20bubbles%20and%20action%20lines%2C%20modern%20Korean%20digital%20comic%20aesthetic&width=1600&height=900&seq=category-hero-01&orientation=landscape"
            alt={`${displayName}韩漫`}
            title={`${displayName}韩漫 - 韩漫画网`}
            className="absolute inset-0 w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
          <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-black text-background-50 font-heading">
              {displayName}韩漫
            </h1>
            <p className="mt-4 text-sm md:text-base text-background-300 max-w-xl mx-auto">
              共 {filteredComics.length} 部作品 · 每日更新 · 无删减完整版
            </p>
          </div>
        </section>

        <section className="py-8 md:py-12 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-8" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-500 transition-colors">首页</Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <span className="text-foreground-800 font-medium">{displayName}韩漫</span>
            </nav>

            <div className="flex flex-wrap items-center gap-2 mb-8">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all ${cat.slug === slug ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-600 hover:bg-background-200'}`}
                >
                  <i className={`${cat.icon} mr-1.5 text-xs`}></i>
                  {cat.name}
                </Link>
              ))}
            </div>

            {filteredComics.length > 0 ? (
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5">
                {filteredComics.map((comic) => (
                  <ComicCard key={comic.id} comic={comic} variant="default" />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-background-100 mb-4">
                  <i className="ri-emotion-sad-line text-2xl text-foreground-400"></i>
                </div>
                <p className="text-foreground-500">该分类暂无漫画作品</p>
                <Link to="/category/all" className="mt-4 inline-block text-sm text-primary-500 hover:text-primary-600 font-medium">
                  浏览全部漫画 →
                </Link>
              </div>
            )}
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}